module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"La cantidad de tu cupón","track":"Your voucher amount"}}